import { Shield, Check, X } from "lucide-react";

/**
 * Modal de consentimiento informado para tratamiento de datos personales
 * conforme a la Ley N° 21.719 de Chile. Reutilizable en formularios públicos
 * que recolectan datos personales (Cotizador, Contacto, etc.).
 */
export default function ConsentModal({ onAccept, onReject, dataDescription }) {
  return (
    <div
      data-testid="consent-modal"
      className="fixed inset-0 z-[100] bg-ink-900/85 backdrop-blur-md flex items-center justify-center p-4"
    >
      <div className="bg-ink-800 border border-ink-500 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="px-8 pt-8 pb-6 border-b border-ink-500">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 border border-brand flex items-center justify-center shrink-0">
              <Shield size={22} strokeWidth={1.5} className="text-brand" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-brand font-mono mb-2">
                Ley 21.719 · Chile
              </div>
              <h2 className="font-display font-bold text-2xl text-ash-100 leading-tight">
                Tratamiento de tus datos personales
              </h2>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="px-8 py-6 space-y-4 text-sm">
          <p className="text-ash-100 leading-relaxed">
            Antes de continuar, necesitamos tu consentimiento informado para el
            tratamiento de los datos personales que nos compartas, en conformidad
            con la Ley N° 21.719 de Protección de Datos Personales de Chile.
          </p>
          <ul className="space-y-3 text-ash-300">
            <ConsentRow label="Responsable">
              DoSoft Ingeniería de Software
            </ConsentRow>
            <ConsentRow label="Datos recopilados">
              {dataDescription ||
                "Nombre, email, teléfono, empresa e información del proyecto que nos compartas en este formulario."}
            </ConsentRow>
            <ConsentRow label="Finalidad">
              Contactarte para responder tu consulta, preparar una propuesta comercial y dar seguimiento.
            </ConsentRow>
            <ConsentRow label="Conservación">
              Mientras dure la relación comercial o hasta que solicites la eliminación de tus datos.
            </ConsentRow>
            <ConsentRow label="Tus derechos">
              Puedes acceder, rectificar, eliminar y oponerte al tratamiento de tus datos en cualquier momento, contactándonos desde la plataforma.
            </ConsentRow>
            <ConsentRow label="Cesión de datos">
              Tus datos no serán compartidos con terceros sin tu autorización explícita.
            </ConsentRow>
          </ul>
        </div>

        {/* Actions */}
        <div className="px-8 py-6 border-t border-ink-500 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3">
          <button
            data-testid="consent-reject"
            onClick={onReject}
            className="px-5 py-3 text-xs uppercase tracking-widest text-ash-300 hover:text-ash-100 inline-flex items-center justify-center gap-2"
          >
            <X size={14} /> No acepto
          </button>
          <button
            data-testid="consent-accept"
            onClick={onAccept}
            className="bg-brand text-ink-800 font-semibold hover:bg-brand-hover px-6 py-3 uppercase tracking-wider text-xs inline-flex items-center justify-center gap-2"
          >
            <Check size={14} strokeWidth={2.5} /> Acepto y continúo
          </button>
        </div>
      </div>
    </div>
  );
}

function ConsentRow({ label, children }) {
  return (
    <li className="grid grid-cols-3 gap-3 border-b border-ink-500 pb-2 last:border-0">
      <dt className="text-[10px] uppercase tracking-widest text-brand font-mono pt-0.5">{label}</dt>
      <dd className="col-span-2 text-ash-100 leading-relaxed">{children}</dd>
    </li>
  );
}
